import React from 'react';
import Modal from 'react-modal';

import {getClassNames} from "../../../services/stylingUtils";

import TransparentButton from '../TransparentButton';

import styles from './style.scss';

class Overlay extends React.Component {

    componentDidMount() {
        Modal.setAppElement(document.getElementById('root'));
    }

    _getStyles() {
        return getClassNames(styles, this.props.className, {
            'content': true
        });
    }

    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                onRequestClose={this.props.onRequestClose}
                className={this._getStyles()}
                overlayClassName={styles['modal-overlay']}
                contentLabel={this.props.ariaLabel}
            >
                <div className={styles['modal-dialog']}>
                    <TransparentButton onClick={this.props.onRequestClose} className={styles['modal-dialog--close']}>
                        <span className="sr-only">Close dialog</span>
                        <span aria-hidden="true">&times;</span>
                    </TransparentButton>

                    {this.props.children}
                </div>
            </Modal>
        );
    }
}

Overlay.defaultProps = {
    ariaLabel: 'Modal'
};

export default Overlay;
